module.exports = __webpack_public_path__ + "img/IOS_logo.dc8f2ced.svg";